var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewspaper = function SvgNewspaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M0 3.75A2.25 2.25 0 0 1 2.25 1.5h16.5A2.25 2.25 0 0 1 21 3.75v15.792c0 .449-.075.982-.356 1.458h1.106a.75.75 0 0 0 .75-.75V6.75a.75.75 0 0 1 1.5 0v13.5a2.25 2.25 0 0 1-2.25 2.25H2.245A2.246 2.246 0 0 1 0 20.25zM18 21c.554 0 .98-.317 1.28-.662.137-.159.22-.418.22-.796V3.75a.75.75 0 0 0-.75-.75H2.25a.75.75 0 0 0-.75.75v16.5c0 .418.334.75.745.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M3 4.5h15v3H3zM3 9h6v4.5H3zM3 15h6v1.5H3zM3 18h6v1.5H3zM10.5 9h3v1.5h-3zM15 9h3v1.5h-3zM10.5 12h3v1.5h-3zM15 12h3v1.5h-3zM10.5 15h3v1.5h-3zM15 15h3v1.5h-3zM10.5 18h3v1.5h-3zM15 18h3v1.5h-3z"
  })));
};
export default SvgNewspaper;